<template>
    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.72021 2.23047H10.1434C11.7502 2.23047 13.2279 3.1185 13.9883 4.54046L28.048 30.8397C29.054 32.7217 31.0076 33.8956 33.1333 33.8956H57.4038L67.2815 8.91925H16.3276"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M29.6325 47.7694C31.8855 47.7694 33.7118 45.9344 33.7118 43.6709C33.7118 41.4073 31.8855 39.5723 29.6325 39.5723C27.3796 39.5723 25.5532 41.4073 25.5532 43.6709C25.5532 45.9344 27.3796 47.7694 29.6325 47.7694Z"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M57.3952 47.7694C59.6482 47.7694 61.4745 45.9344 61.4745 43.6709C61.4745 41.4073 59.6482 39.5723 57.3952 39.5723C55.1423 39.5723 53.3159 41.4073 53.3159 43.6709C53.3159 45.9344 55.1423 47.7694 57.3952 47.7694Z"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.2"
            d="M65.5275 8.91797H57.4702C57.4702 16.0166 54.5925 22.4405 49.9887 27.0981C45.353 31.7237 38.9593 34.615 31.894 34.615H55.296L65.5261 8.91797H65.5275Z"
            fill="currentColor" />
    </svg>
</template>